import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CostCenterSummary, Identity } from '@libs/core/api';
import { GuideDoc } from '@libs/ui/uikit';

@Component({
  selector: 'front-end-fund-cash-purchase-modal',
  templateUrl: './fund-cash-purchase-modal.component.html',
  styleUrls: ['./fund-cash-purchase-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPurchaseModalComponent {
  @Input() project!: CostCenterSummary;
  @Input() identity!: Identity;

  dontShowAgain = false;

  readonly fundCashDocs: GuideDoc[] = [
    {
      icon: 'create-outline',
      descriptionKey: 'pages.guide.fund-cash.budget',
    },
    {
      icon: 'card-outline',
      descriptionKey: 'pages.guide.fund-cash.card',
    },
    {
      icon: 'camera-outline',
      descriptionKey: 'pages.guide.fund-cash.receipt',
    },
    {
      icon: 'paper-plane-outline',
      descriptionKey: 'pages.guide.fund-cash.send',
    },
  ];

  constructor(private modalController: ModalController) {}

  close(): void {
    this.modalController.dismiss();
  }

  createFundCash(): void {
    if (this.dontShowAgain) {
      localStorage.setItem('hideFundCashGuide', 'true');
    }

    this.modalController.dismiss({ action: 'create' });
  }
}
